<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="district.districtID ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')"
    >
      <el-form ref="form" :model="district" :rules="ruleValidate" class="form" label-width="80px">
        <el-form-item label="区域编号">
          <el-input v-model="district.districtNO" disabled />
        </el-form-item>
        <el-form-item label="区域名称" prop="districtName">
          <el-input v-model="district.districtName" placeholder="请输入区域名称" />
        </el-form-item>
        <el-form-item v-if="district.flevel !== 1" label="上级区域" prop="parentID">
          <el-select v-model="district.parentName" clearable placeholder="请选择上级区域">
            <el-option v-for="item in parentNameList" :key="item.districtID" :label="item.districtName" :value="item.districtID" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="district.note" type="textarea" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      parentNameList: [],
      district: {
        districtID: "",
        districtNO: "",
        fLevel: "",
        districtName: "",
        note: "",
        parentID: "",
        parentName: "",
      },
      ruleValidate: {
        districtName: { required: true, message: "请输入区域名称", trigger: "blur" },
        parentID: { required: true, message: "请选择上级区域", trigger: "change" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      this.getParentNameList();
      if (row) {
        this.district = Object.assign(this.district, row);
      } else {
        this.getNote();
      }
    },

    // 获取上级区域列表
    getParentNameList() {
      this.$http.get("basic", "districts/firstLevelList").then((resp) => {
        if (resp.success) {
          this.parentNameList = resp.data;
        }
      });
    },

    // 获取区域编号
    getNote() {
      this.$http.get("basic", "districts/selectNo").then((resp) => {
        if (resp.success) {
          this.district.districtNO = resp.data;
        }
      });
    },

    // 提交
    handleSubmit() {
      if (this.district.districtID) {
        this.handleSubmitUpData();
      } else {
        this.handleSubmitSave();
      }
    },

    // 编辑
    handleSubmitUpData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .put("basic", "districts", this.district)
            .then((resp) => {
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success("编辑成功");
              }
              this.submitLoading = false;
              this.dialogVisible = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // 新建
    handleSubmitSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post("basic", "districts", this.district)
            .then((resp) => {
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success("添加成功");
              }
              this.submitLoading = false;
              this.dialogVisible = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
